import { render } from "./TurnoverCorpCard.vue?vue&type=template&id=389f4338"
import script from "./TurnoverCorpCard.vue?vue&type=script&lang=js"
export * from "./TurnoverCorpCard.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__